// import Cookies from 'js-cookie';
// import md5 from 'js-md5'

const order = {
    state: {
        pageSize: 4,
        pageIndex: 1,
        total: 1,
        filterStr: 'all'
    },

    mutations: {
        SET_PAGE_INDEX: (state, data) => {
            state.pageIndex = data;
        },
        SET_TOTAL: (state, data) => {
            state.total = data;
        },
        SET_FILTER_STR: (state, data) => {
            state.filterStr = data;
            state.pageIndex = 1;
        }
    },
};

export default order;



// WEBPACK FOOTER //
// ./src/store/modules/order.js